
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import { getOrderList, tableExport } from '@/api/task/order'
import { Form as ElForm } from 'element-ui'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import { auditStatusList, timeTypeList } from '@/utils/constant'
import orderDetail from './components/orderDetail.vue'
import review from './components/review.vue'
import { AppModule } from '@/store/modules/app'
import batchReview from './components/batchReview.vue'

@Component({
  name: 'depositIndex',
  components: {
    pagination,
    orderDetail,
    review,
    batchReview
  }
})
export default class extends mixins(productOptionMixin, currencyOptionMixin) {
  queryForm: any = {
    start_time: null,
    end_time: null,
    status: null,
    begin_handle_time: null,
    end_handle_time: null,
    handle_time_unit: timeTypeList[0],
    min_amount: null,
    max_amount: null,
    id: null,
    content: null
  }
  private statusList: any[] = auditStatusList
  private timeTypeList = timeTypeList
  private date: any[] = getCurrentDate()
  private handleDate: any[] = []
  private pickerOptions = pickerOptions
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }

  private currentOrder: any | null = null
  private drawer: boolean = false
  private dialogVisible: boolean = false

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private isShowIp: boolean = false

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      this.orderList = []
      await getOrderList(data).then((res: any) => {
        this.total = res.count
        this.orderList = res.results
        let a = this.orderList.findIndex(obj => obj.ip)
        if (a === 0) {
          this.isShowIp = true
        }
        console.log(a)
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private selectList: any[] = []
  private handleSelectionChange(list) {
    this.selectList = list
  }

  private batchReview: boolean = false
  private ordernumbers: any[] = []
  private openBatch() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (
        this.selectList[i].status === '0' ||
        this.selectList[i].status === 0
      ) {
        this.ordernumbers.push(this.selectList[i].id)
      }
    }
    this.batchReview = true
  }
  private closeBatch() {
    this.batchReview = false
    this.hadleGetFilesListApi()
  }

  private openDialog(param: any) {
    this.currentOrder = param
    this.dialogVisible = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.currentOrder = null
    // this.getOrderList(false)
    this.hadleGetFilesListApi()
  }

  private openDrawer(param: any) {
    this.currentOrder = param
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrder = null
    // this.getOrderList(false)
    this.hadleGetFilesListApi()
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      start_time: null,
      end_time: null,
      status: null,
      begin_handle_time: null,
      end_handle_time: null,
      handle_time_unit: timeTypeList[0],
      product_name: null,
      product_account_name: null,
      min_amount: null,
      max_amount: null,
      id: null
    }
    this.date = getCurrentDate()
    this.handleDate = []
    this.currentPage = 1
    this.pickerChange()
    // this.getOrderList(true)
    this.hadleGetFilesListApi()
  }

  private async getOrderList(isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page: this.listQuery.page
      }
      delObjEmptyKey(data)
      await getOrderList(data).then((res: any) => {
        this.total = res.count
        this.orderList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await tableExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }
  created() {}

  private async init() {
    // this.getOrderList(true)
    await this.hadleGetFilesListApi()
  }
  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.depositReview`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
